/**
 * 用户埋点行为数据（GET /appTrack）。
 */
export interface AppTrack {
  id: string;
  /** 用户 ID */
  user_id: string;
  /** 事件名称 */
  event: string;
  /** 事件时间（ISO 或时间戳字符串） */
  event_time: string;
  /** 事件附加属性 */
  properties: Record<string, unknown> | null;
  /** 原始响应字段 */
  raw: Record<string, unknown>;
}

/** 货源数据页可下拉查询的单一事件选项。 */
export const APP_TRACK_QUERY_EVENTS = [
  "view_cargo_detail",
  "open_app",
  "query_cargo_list_by_origin",
] as const;

/** 默认查询事件。 */
export const APP_TRACK_DEFAULT_EVENT = "view_cargo_detail" as const;
